import React from "react";
import { Chart } from "primereact/chart";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { dashboardApi } from "../../services/dashboard/dashboardApi";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Dashboard = () => {
  const [studentsCount, setStudentCount] = useState(1200);
  const [teachersCount, setTeacherCount] = useState(150);
  const [disciplinesCount, setDisciplineCount] = useState(35);

  // Hardcoded sample data for visualization
  const [enrollmentTrends, _setEnrollmentTrends] = useState([
    { month: "Януари", count: 100 },
    { month: "Февруари", count: 120 },
    { month: "Март", count: 150 },
    { month: "Април", count: 200 },
    { month: "Май", count: 180 },
    { month: "Юни", count: 220 },
    { month: "Юли", count: 240 },
    { month: "Август", count: 260 },
    { month: "Септември", count: 300 },
    { month: "Октомври", count: 280 },
    { month: "Ноември", count: 310 },
    { month: "Декември", count: 320 },
  ]);

  const [metricsComparison, _setMetricsComparison] = useState([studentsCount, teachersCount, disciplinesCount]);

  const { data: dashboardInfo } = dashboardApi.useGetDashboardInfoQuery();

  useEffect(() => {
    if (dashboardInfo) {
      setStudentCount(dashboardInfo?.data.studentsCount);
      setTeacherCount(dashboardInfo?.data.teachersCount);
      setDisciplineCount(dashboardInfo?.data.disciplinesCount);
    }
  }, [dashboardInfo]);

  const pieData = {
    labels: ["Студенти", "Преподаватели", "Дисциплини"],
    datasets: [
      {
        data: [studentsCount, teachersCount, disciplinesCount],
        backgroundColor: ["#42A5F5", "#66BB6A", "#FFA726"],
        hoverBackgroundColor: ["#64B5F6", "#81C784", "#FFB74D"],
      },
    ],
  };

  const barData = {
    labels: ["Студенти", "Преподаватели", "Дисциплини"],
    datasets: [
      {
        label: "Брой",
        backgroundColor: ["#42A5F5", "#66BB6A", "#FFA726"],
        data: [studentsCount, teachersCount, disciplinesCount],
      },
    ],
  };

  const lineData = {
    labels: enrollmentTrends.map((data) => data.month),
    datasets: [
      {
        label: "Брой записани студенти",
        data: enrollmentTrends.map((data) => data.count),
        borderColor: "#42A5F5",
        fill: false,
      },
    ],
  };

  const radarData = {
    labels: ["Студенти", "Преподаватели", "Дисциплини"],
    datasets: [
      {
        label: "Metrics Comparison",
        backgroundColor: "rgba(179,181,198,0.2)",
        borderColor: "rgba(179,181,198,1)",
        pointBackgroundColor: "rgba(179,181,198,1)",
        pointBorderColor: "#fff",
        data: metricsComparison,
      },
    ],
  };

  //TODO - move css into separate file
  const cardStyle: React.CSSProperties = {
    margin: "10px",
    textAlign: "center",
  };

  const gridStyle: React.CSSProperties = {
    display: "flex",
    flexWrap: "wrap",
    margin: "20px",
  };

  const columnStyle = (width: string): React.CSSProperties => ({
    width: width,
    padding: "10px",
  });

  const chartStyle = {
    width: "100%",
    height: "100%",
  };

  const pieChartOptions = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "left",
        labels: {
          textAlign: "left",
        },
      },
    },
  };

  const chartContainerStyle: React.CSSProperties = {
    position: "relative",
    height: "300px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const iconStyle = {
    fontSize: "2.5em",
    color: "#42A5F5",
    marginBottom: "10px",
  };

  const cardHeaderStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  return (
    <div style={gridStyle}>
      <div style={{ width: "100%" }}></div>

      <div style={columnStyle("33.33%")}>
        <Link to="/students" style={{ textDecoration: "none", color: "inherit" }}>
          <Card style={cardStyle}>
            <div style={cardHeaderStyle}>
              <i className="pi pi-user" style={iconStyle}></i>
              <h2>Брой студенти</h2>
            </div>
            <div>
              <h2 style={{ margin: 0 }}>{studentsCount}</h2>
            </div>
          </Card>
        </Link>
      </div>

      <div style={columnStyle("33.33%")}>
        <Card style={cardStyle}>
          <div style={cardHeaderStyle}>
            <i className="pi pi-users" style={iconStyle}></i>
            <h2>Брой преподаватели</h2>
          </div>
          <div>
            <h2 style={{ margin: 0 }}>{teachersCount}</h2>
          </div>
        </Card>
      </div>

      <div style={columnStyle("33.33%")}>
        <Link to="/nomenclatures/specialities" style={{ textDecoration: "none", color: "inherit" }}>
          <Card style={cardStyle}>
            <div style={cardHeaderStyle}>
              <i className="pi pi-folder" style={iconStyle}></i>
              <h2>Брой дисциплини</h2>
            </div>
            <div>
              <h2 style={{ margin: 0 }}>{disciplinesCount}</h2>
            </div>
          </Card>
        </Link>
      </div>

      <Divider />

      <div style={columnStyle("50%")}>
        <Card title="" style={cardStyle}>
          <div style={chartContainerStyle}>
            <Chart type="pie" data={pieData} options={pieChartOptions} style={chartStyle} />
          </div>
        </Card>
      </div>

      <div style={columnStyle("50%")}>
        <Card title="" style={cardStyle}>
          <Chart type="bar" data={barData} style={chartStyle} />
        </Card>
      </div>

      <div style={columnStyle("50%")}>
        <Card title="Брой записани студенти" style={cardStyle}>
          <Chart type="line" data={lineData} style={chartStyle} />
        </Card>
      </div>

      <div style={columnStyle("50%")}>
        <Card title="Metrics Comparison" style={cardStyle}>
          <Chart type="radar" data={radarData} style={chartStyle} />
        </Card>
      </div>
    </div>
  );
};

export default Dashboard;
